module.exports = __webpack_public_path__ + "static/media/order-success-icon.ca7d314e.svg";